import Enllac from 'components/corporatiu/Enllac/Enllac';
import Imatge from 'components/corporatiu/Imatge';
import styles from './empresessolidaries.module.scss';
import Desplegable from 'components/corporatiu/Desplegable';
import __isEmpty from 'lodash/isEmpty';

const getLocalizedField = (item, lang, field) => {
    if (lang === 'es') return item[`${field}ES`];
    if (lang === 'en') return item[`${field}EN`];

    return item[field];
};

const EmpresesSolidariesMarato = ({ colaboradors, patrocinadors, entitats, lang, texts }) => {
    return (
        <div className={styles.empresesSolidaries}>
            {!__isEmpty(colaboradors) && (
                <>
                    <h2>{texts.titolColabos}</h2>
                    <p>{texts.entradetaColabos}</p>
                    <div className={styles.colaboradors}>
                        <ul className={styles.llista}>
                            {colaboradors.map((colaborador) => {
                                const title = getLocalizedField(colaborador, lang, 'title');

                                return (
                                    <li className={styles.colaborador} key={colaborador.url}>
                                        <Enllac href={colaborador.url} title={title} novaFinestra={true}>
                                            <Imatge
                                                src={
                                                    'https://statics.3cat.cat/recursos/marato/img/empreses/' +
                                                    colaborador.img +
                                                    '.png'
                                                }
                                                alt={colaborador.altImg}
                                                layout='fill'
                                                objectFit='contain'
                                            />
                                        </Enllac>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </>
            )}
            {!__isEmpty(patrocinadors) && (
                <>
                    <h2>{texts.titolEntitats}</h2>
                    <p>{texts.entradetaEntitats}</p>
                </>
            )}
            <div className={styles.patrocinadors}>
                <ul className={styles.llista}>
                    {patrocinadors.map((patrocinador) => (
                        <li key={patrocinador.url}>
                            <Enllac href={patrocinador.url} title={patrocinador.title} novaFinestra={true}>
                                <Imatge
                                    src={'https://statics.3cat.cat/recursos/marato/img/empreses/' + patrocinador.img + '.png'}
                                    alt={patrocinador.altImg}
                                    width={102}
                                    height={64}
                                />
                            </Enllac>
                        </li>
                    ))}
                </ul>
            </div>
            {entitats.some((entitat) => getLocalizedField(entitat, lang, 'name')) && (
                <>
                    <h2>{texts.titolEmpreses}</h2>
                    <p>{texts.entradetaEmpreses}</p>
                    {entitats.map((entitat) => {
                        const titol = getLocalizedField(entitat, lang, 'name');

                        return (
                            <Desplegable titol={titol} key={titol}>
                                <div className={styles.desplegable}>
                                    <ul>
                                        {entitat.items.map((item) => (
                                            <li key={titol + item.name}>
                                                {item.url ? (
                                                    <Enllac href={item.url} novaFinestra={true}>
                                                        {item.name}
                                                    </Enllac>
                                                ) : (
                                                    item.name
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Desplegable>
                        );
                    })}
                </>
            )}
        </div>
    );
};

export default EmpresesSolidariesMarato;
